import { render, staticRenderFns } from "./add-postal.vue?vue&type=template&id=7da005c4&scoped=true&"
import script from "./add-postal.vue?vue&type=script&lang=js&"
export * from "./add-postal.vue?vue&type=script&lang=js&"
import style0 from "./add-postal.vue?vue&type=style&index=0&id=7da005c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da005c4",
  null
  
)

export default component.exports